import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoPieChartOutline, IoShieldOutline, IoDiamondOutline, IoTrendingUpOutline, IoNewspaperOutline, IoChatbubbleOutline, IoDocumentTextOutline, IoChevronDownOutline, IoChevronUpOutline, IoBarChartOutline, IoLogOutOutline, IoCloseOutline, IoKeyOutline, IoShareSocialOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

export default function AccountSidebar({ activeItem = "hesap-ozeti" }) {
    const { t } = useTranslation();
    const { logout } = useAuth();
    const [isTransactionHistoryOpen, setIsTransactionHistoryOpen] = useState(false);
    const [isPositionsOpen, setIsPositionsOpen] = useState(false);

    const menuItems = [
        { id: "hesap-ozeti", label: t('accountSidebar.accountSummary'), icon: IoPieChartOutline, path: "/account-summary" },
        { id: "guvenlik-ayarlari", label: t('accountSidebar.twoFactorAuth'), icon: IoShieldOutline, path: "/two-factor-auth" },
        { id: "referans-kodu", label: t('accountSidebar.referralCode'), icon: IoShareSocialOutline, path: "/referral-code" },
        { id: "tercih-ayarlari", label: t('accountSidebar.changePassword'), icon: IoKeyOutline, path: "/change-password" },
        // { id: "haber-merkezi", label: "Haber Merkezi", icon: IoNewspaperOutline, path: "/news-center" },
    ];

    const transactionHistorySubItems = [
        { id: "yatirim-gecmisi", label: t('accountSidebar.deposits'), path: "/deposits" },
        { id: "kripto-cekim", label: t('accountSidebar.cryptoWithdrawals'), path: "/crypto-withdrawals" },
        { id: "banka-cekim", label: t('accountSidebar.bankWithdrawals'), path: "/bank-withdrawals" },
    ];

    const positionsSubItems = [
        { id: "acik-pozisyonlar", label: t('accountSidebar.openPositions'), path: "/open-positions" },
        { id: "kapali-pozisyonlar", label: t('accountSidebar.closedPositions'), path: "/closed-positions" },
    ];


    return (
        <div className='account-sidebar'>
            <div className="sidebar-menu">
                    {menuItems.map((item) => {
                        const IconComponent = item.icon;
                        return (
                            <Link
                                key={item.id}
                                to={item.path}
                                className={`menu-item ${activeItem === item.id ? 'active' : ''}`}
                            >
                                <IconComponent size={20} />
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}

                {/* İşlem Geçmişi Accordion */}
                <div className="accordion-item">
                    <button
                        className={`accordion-header ${isTransactionHistoryOpen ? 'open' : ''}`}
                        onClick={() => setIsTransactionHistoryOpen(!isTransactionHistoryOpen)}
                    >
                        <div>
                            <IoDocumentTextOutline size={20} style={{ marginRight: '5px' }} />
                            <span>{t('accountSidebar.transactionHistory')}</span>
                        </div>
                        {isTransactionHistoryOpen ? <IoChevronUpOutline size={16} /> : <IoChevronDownOutline size={16} />}
                    </button>

                    {isTransactionHistoryOpen && (
                        <div className="accordion-content">
                            {transactionHistorySubItems.map((subItem) => (
                                <Link
                                    key={subItem.id}
                                    to={subItem.path}
                                    className={`sub-menu-item ${activeItem === subItem.id ? 'active' : ''}`}
                                >
                                    <span>{subItem.label}</span>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>

                {/* Pozisyonlar Accordion */}
                <div className="accordion-item">
                    <button
                        className={`accordion-header ${isPositionsOpen ? 'open' : ''}`}
                        onClick={() => setIsPositionsOpen(!isPositionsOpen)}
                    >
                        <div>
                            <IoBarChartOutline size={20} style={{ marginRight: '5px' }} />
                            <span>{t('accountSidebar.positions')}</span>
                        </div>
                        {isPositionsOpen ? <IoChevronUpOutline size={16} /> : <IoChevronDownOutline size={16} />}
                    </button>

                    {isPositionsOpen && (
                        <div className="accordion-content">
                            {positionsSubItems.map((subItem) => (
                                <Link
                                    key={subItem.id}
                                    to={subItem.path}
                                    className={`sub-menu-item ${activeItem === subItem.id ? 'active' : ''}`}
                                >
                                    <span>{subItem.label}</span>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>

                <div className='profile-logout-section-sidebar'>
                    <button
                        className='profile-logout-btn-sidebar'
                        onClick={logout}
                    >
                        <IoLogOutOutline size={20} />
                        <span>{t('common.logout')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
